import { combineReducers } from 'redux'

import stagedRecord from './stagedRecord'

const index = combineReducers({
  stagedRecord,
})

export default index
